import { useTranslate } from '../../hooks/useTranslate';
import { useCEProductCustomization } from '../../bitf-customization-engine/useCEProductCustomization';

export default function CEProductCustomizationButton({
  storeName,
  language = 'it',
  drawerId = 'product-customization-drawer',
  buttonText = 'Customize',
}) {
  const { translate } = useTranslate(language);
  const { store } = useCEProductCustomization({
    storeName: storeName,
    watchStoreChanges: false,
  });

  const handleClick = () => {
    // Show the customization preview in the gallery by removing hidden attribute
    const customizationPreview = document.querySelector('[data-media-id="customization-preview"]');
    if (customizationPreview) {
      customizationPreview.removeAttribute('hidden');
      // Mark as user-requested visible so variant changes don't re-hide it
      customizationPreview.setAttribute('data-customization-visible', '');
      // Scroll to the customization preview
      customizationPreview.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }

    // Also show the carousel navigation control for the customization preview
    const carouselNavigation = document.querySelector('carousel-navigation');
    if (carouselNavigation) {
      const customizationControl = carouselNavigation.querySelector('button[hidden]');
      if (customizationControl) {
        customizationControl.removeAttribute('hidden');
      }
    }

    // Open the drawer
    const drawer = document.getElementById(drawerId);
    if (drawer && typeof drawer.show === 'function') {
      drawer.show();
    } else {
      // Fallback: try to find a button that controls the drawer
      const drawerButton = document.querySelector(`[aria-controls="${drawerId}"]`);
      if (drawerButton && drawerButton !== document.activeElement) {
        drawerButton.click();
      }
    }
  };

  return (
    <button
      type="button"
      className="ASRomaFont Small ExtraBold asroma-button button--outline button-primary w-full Uppercase"
      onClick={handleClick}
      disabled={!store.currentProductVariant || store.isLoadingCustomization !== false}
    >
      {buttonText}
    </button>
  );
}
